import React, {Component} from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import NRTFormContainer from "../../../../components/_common/_form/_containers/FormContainer"
import NRTVerticalStack from "../../../../components/_common/_containers/VerticalStack"
import NRTSaleActionBar from "../../../../components/_sale/ActionButtonBar"
import Fade from "../../../../components/_common/_transitions/Fade"
import SaleInfo from "./_components/SaleInfo"
import BackButton from "../../../../components/_common/_buttons/BackButton"
import MCLoadingOverlay from "../../../../components/_minha-central/LoadingOverlay"
import NRTButton from "../../../../components/_common/_buttons/Button"
import {PaymentMethodsEnum} from "../../../../enums/PaymentMethodsEnum"
import {PaymentPartnersEnum} from "../../../../enums/PaymentPartnersEnum"


class ConfirmationStep extends Component {

    static UNIQUE_SALE_PER_CPF_ERROR_MSG = 'Este curso permite apenas uma compra por CPF.'

    state = {
        initialized: false,
        confirmed: false,
        bankBilletUrl: "",
        awaiting: false,
    }


    componentDidMount() {
        const {context} = this.props

        this.setState({
            initialized: true,
            buyer: context.saleBuyer,
            responsible: context.saleResponsible,
            release: context.saleRelease,
            guests: context.saleGuests,
            payment: context.salePayment,
            confirmed: context.saleConfirmed || false ,
        })
    }

    componentWillUnmount(){
        this.props.context.set({
            saleConfirmed: false
        })
    }


    onError = (error) => {
        this.props.context.set({
            toastMessage: {
                type: 'error',
                content: error.text || 'Ocorreu um erro ao efetuar a venda.'
            }
        })

        this.props.context.logError(error, {
            releaseName: this.state.release.name,
            releaseCode: this.state.release.code,
            payment: this.state.payment,
        })
    }


    _doSale = () => {

        const context = this.props.context

        if (this.state.awaiting)
            return

        // valida se venda tem responsavel
        if (!_.get(context, 'saleResponsible.code', false))
            return console.error('Sem responsavel pela venda.')

        // valida se responsavel nao é pessoa fisica.
        if (!!_.get(context, 'saleResponsible.isLegal'))
            return console.error('Responsavel nao pode ser pessoa fisica.')

        this.setState({awaiting: true},
            () => {

                const {
                    saleValue,
                    unitValue,
                    installmentNumber,
                    voucherName,
                    paymentMethod,
                } = context.salePayment

                this.props.doSale(
                    context.saleResponsible.code,
                    context.saleBuyer.code,
                    context.saleRelease.code,
                    context.saleGuests,
                    saleValue,
                    unitValue,
                    paymentMethod,
                    installmentNumber,
                    voucherName,
                    context.salePaymentPartnerCode,

                ).then((saleResult) => {

                    const confirmationUrl = _.get(saleResult, 'confirmationUrl')


                    if (!!confirmationUrl && paymentMethod === PaymentMethodsEnum.CREDIT_CARD.code
                        && context.salePaymentPartnerCode !== PaymentPartnersEnum.IPAG.code
                    )
                        return this.redirect(confirmationUrl)


                    if (_.get(saleResult, 'errorMessages[0]', '').startsWith("Ops! Produto não aceita mais de uma compra por CPF")) {
                        this.onError({text: ConfirmationStep.UNIQUE_SALE_PER_CPF_ERROR_MSG})
                        return this.setState({awaiting: false})
                    }

                    if (!saleResult.invoiceAccountCode) {
                        this.onError({text: _.get(saleResult, 'errorMessages[0]', '')})
                        return this.setState({awaiting: false})
                    }


                    // Atualiza estado
                    this.setState({
                        confirmed: true,
                        bankBilletUrl: saleResult.bankBilletUrl || "",
                        awaiting: false,
                    })


                })
                    .catch((err) => {

                        console.error(err)
                        this.onError(err)

                        this.setState({awaiting: false})
                    })

            })

    }

    doSale = _.debounce(this._doSale, 300)


    redirect(url) {
        window.location.replace(url)
    }


    finishSale = () => {
        this.props.context.set({
            saleRelease: null,
            saleCourseData: null,
            saleGuests: null,
            saleResponsible: null,
            saleBuyer: null,
            salePayment: null,
        })
        this.props.goToHome()
    }


    render() {

        const context = this.props.context
        const paymentMethod = _.get(context, 'salePayment.paymentMethod')


        const {
            initialized,
            confirmed,
            awaiting,
        } = this.state


        if (!initialized)
            return null


        return (

            <React.Fragment>
                {
                    !confirmed &&
                    <BackButton onClick={this.props.goToPreviousStep}/>
                }
                <NRTFormContainer title={'Resumo da compra'}>

                    <MCLoadingOverlay show={awaiting}/>

                    <NRTVerticalStack fractions={[1, 1]}>

                        {/*Dados da compra*/}
                        {
                            !confirmed &&
                            <SaleInfo buyer={context.saleBuyer}
                                      release={context.saleRelease}
                                      guests={context.saleGuests}
                                      payment={context.salePayment}

                                      image={_.get(context, 'saleRelease.mainImageUrl') ||
                                      _.get(context, 'saleCourseData.image')}
                            />
                        }

                        {/*Agradecimento*/}
                        {
                            confirmed &&
                            <div style={{position: 'relative', minHeight: '30rem'}}>
                                <Fade
                                    in={confirmed}
                                    delay={150}
                                    style={{
                                        position: 'absolute',
                                        top: '2.5rem',
                                        margin: '0 auto',
                                        width: '100%',
                                        textAlign: 'center'
                                    }}
                                >
                                    <div>
                                        <h3>Obrigado,</h3>
                                        <h4 style={{fontSize: '1.5rem'}}>Sua compra foi efetuada com sucesso!</h4>
                                        <div className="nrt-sale-info">
                                            <div className="item-sale">
                                                <img src={`${this.props.context.saleCourseData.image}`}/>
                                                <p>{this.props.context.saleCourseData.title}</p>
                                            </div>
                                        </div>
                                        <div id="button-imprimir-boleto" style={{fontSize: '1.2rem'}}>
                                            {

                                                this.state.bankBilletUrl !== "" &&
                                                (
                                                    <NRTButton
                                                        style={{display: 'inline-flex'}}
                                                        onClick={() => window.open(this.state.bankBilletUrl, '_blank')}
                                                        content={"Imprimir Boleto"}/>

                                                )
                                            }
                                        </div>
                                    </div>


                                </Fade>
                            </div>
                        }

                        {/*Btn: Finalizar compra*/}
                        <NRTSaleActionBar
                            disabled={awaiting}
                            loading={awaiting}
                            onClick={confirmed ? this.finishSale : this.doSale}
                            buttonLabel={(() => {
                                if (awaiting)
                                    return 'POR FAVOR, AGUARDE'

                                if (confirmed)
                                    return 'VOLTAR AO INÍCIO'

                                if (paymentMethod === PaymentMethodsEnum.CREDIT_CARD.code)
                                    return 'AVANÇAR'

                                return 'COMPRAR'

                            })()}
                        />

                    </NRTVerticalStack>
                </NRTFormContainer>
            </React.Fragment>
        )
    }
}


ConfirmationStep.propTypes = {
    context: PropTypes.object.isRequired,
    doSale: PropTypes.func.isRequired,
    goToHome: PropTypes.func.isRequired,
    goToPreviousStep: PropTypes.func.isRequired,
    onSaleComplete: PropTypes.func.isRequired,
}


export default ConfirmationStep



// WEBPACK FOOTER //
// ./src/_pages/Sale/_partials/ConfirmationStep/index.js